import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  chartSkeleton: {
    width: '100%',
    height: theme.spacing(4),
    margin: theme.spacing(2, 0),
    backgroundColor: theme.palette.insights.noData,
    borderRadius: theme.spacing(0),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },

  legendContainer: {
    height: theme.spacing(59),
    backgroundColor: theme.palette.insights.noData,
    borderRadius: theme.spacing(0),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  text: {
    fontSize: theme.spacing(1.6)
  }
}));
const SourceByTimeChartNoData: React.FC = () => {
  const classes = useStyles();
  return (
    <Grid container data-testid={'source-by-time-chart-no-data-found'}>
      <Grid item xs={12}>
        <Paper elevation={0} className={classes.chartSkeleton}>
          <Typography className={classes.text}>
            <FormattedMessage id={'insights.timeSheetLabels.na'} />
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper elevation={0} className={classes.legendContainer}>
          <Typography variant="body2">
            <FormattedMessage
              id={'insights.timeBreakdownChart.noDataMessage'}
            />
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default SourceByTimeChartNoData;
